<template>
	<div>
		<div>
			<v-dialog :eager="true" v-model="sendMessageDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
				<SendMessage ref="sendMessageDialog" @close="closeSendMesage" style="height:100%">
				</SendMessage>
			</v-dialog>
			<div v-show="premises.length > 0">
				<v-data-table :headers="headers"
						    :items="premises"
						    class="elevation-1"
						    :loading="loading">
					<template v-slot:item.actions="{ item }">
						<v-btn icon v-if="$permissionHolder.hasPermission('FIRST_ALERT.ANNOUNCE')" v-on:click="openSendMessage(item.id)">
							<v-icon dark>mdi-bullhorn</v-icon>
						</v-btn>
					</template>
				</v-data-table>
			</div>
		</div>
	</div>
</template>

<script>

import api from "@/api";
import SendMessage from "@/components/premise/SendMessage";


export default {
  name: "PremiseCommunications.vue",
	components: {SendMessage},
	data() {
		return {
			premises : [],
			loading : false,
			sendMessageDialog : false,
			pagination: {
				sortBy : ['name'],
				sortOrder : ['ASC']
			},
			headers : [
				{text:'Name',value:'name'},
				{text:'Actions',value:'actions'}
			]
		}
	},
	mounted() {
		this.getPremises();
	},
	methods : {
		closeSendMesage () {
			this.sendMessageDialog = false;
		},
		openSendMessage (id) {
			this.sendMessageDialog = true;
			this.$refs.sendMessageDialog.open(Number(id));
		},
		getPremises() {
			this.loading = true;
			return new Promise((resolve,reject) => {
				api.premise.search({
					pageNumber: this.pagination.page - 1,
					rowsPerPage: this.pagination.itemsPerPage,
					sortBy: this.pagination.sortBy,
					sortOrder: this.pagination.sortOrder,
					organizationId: this.$userHolder.getPrimaryOrganizationId()
				}).then(response => {
					this.premises = response.list;
					this.totalRecords = response.totalRecords;
					resolve();
				}).catch(error => {
					reject();
				}).finally(() => {
					this.loading = false;
				});
			});
		}
	}
}
</script>